import { c as _c } from "react/compiler-runtime";
import type { RefObject } from "react";
import type { ApiCreateGroup } from "@/generated/models/ApiCreateGroup";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { CreateWaveStep } from "@/types/waves.types";
import CreateWaveDates from "./dates/CreateWaveDates";
import type { CreateWaveDescriptionHandles } from "./description/CreateWaveDescription";
import CreateWaveDescription from "./description/CreateWaveDescription";
import CreateWaveDrops from "./drops/CreateWaveDrops";
import CreateWaveGroups from "./groups/CreateWaveGroups";
import type { useWaveConfig } from "./hooks/useWaveConfig";
import CreateWaveOutcomes from "./outcomes/CreateWaveOutcomes";
import CreateWaveOverview from "./overview/CreateWaveOverview";
import CreateWaveVoting from "./voting/CreateWaveVoting";
type WaveConfigController = ReturnType<typeof useWaveConfig>;
export default function CreateWaveStepContent(t0) {
  const $ = _c(61);
  const {
    controller,
    profile,
    descriptionRef,
    showDropError,
    onHaveDropToSubmitChange,
    onInlineGroupCreate
  } = t0;
  const {
    config,
    step,
    selectedOutcomeType,
    errors,
    groupsCache,
    setOverview,
    setDates,
    setDrops,
    setOutcomes,
    setDropsAdminCanDelete,
    onOutcomeTypeChange,
    onGroupSelect,
    onVotingTypeChange,
    onCategoryChange,
    onProfileIdChange,
    onMaxVotesPerIdentityPerDropChange,
    onTimeWeightedVotingChange,
    onThresholdChange,
    onApprovalMaxWinnersChange,
    onChatEnabledChange
  } = controller;
  switch (step) {
    case CreateWaveStep.OVERVIEW:
      {
        let t1;
        if ($[0] !== config.overview || $[1] !== errors || $[2] !== setOverview) {
          t1 = <CreateWaveOverview overview={config.overview} errors={errors} setOverview={setOverview} />;
          $[0] = config.overview;
          $[1] = errors;
          $[2] = setOverview;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case CreateWaveStep.GROUPS:
      {
        let t1;
        if ($[4] !== config.chat.enabled || $[5] !== config.drops.adminCanDeleteDrops || $[6] !== config.groups || $[7] !== config.overview.name || $[8] !== config.overview.type || $[9] !== groupsCache || $[10] !== onChatEnabledChange || $[11] !== onGroupSelect || $[12] !== onInlineGroupCreate || $[13] !== setDropsAdminCanDelete) {
          t1 = <CreateWaveGroups waveName={config.overview.name} waveType={config.overview.type} groups={config.groups} groupsCache={groupsCache} chatEnabled={config.chat.enabled} adminCanDeleteDrops={config.drops.adminCanDeleteDrops} setChatEnabled={onChatEnabledChange} onGroupSelect={onGroupSelect} onInlineGroupCreate={onInlineGroupCreate} setDropsAdminCanDelete={setDropsAdminCanDelete} />;
          $[4] = config.chat.enabled;
          $[5] = config.drops.adminCanDeleteDrops;
          $[6] = config.groups;
          $[7] = config.overview.name;
          $[8] = config.overview.type;
          $[9] = groupsCache;
          $[10] = onChatEnabledChange;
          $[11] = onGroupSelect;
          $[12] = onInlineGroupCreate;
          $[13] = setDropsAdminCanDelete;
          $[14] = t1;
        } else {
          t1 = $[14];
        }
        return t1;
      }
    case CreateWaveStep.DATES:
      {
        let t1;
        if ($[15] !== config.dates || $[16] !== config.overview.type || $[17] !== errors || $[18] !== setDates) {
          t1 = <CreateWaveDates waveType={config.overview.type} dates={config.dates} errors={errors} setDates={setDates} />;
          $[15] = config.dates;
          $[16] = config.overview.type;
          $[17] = errors;
          $[18] = setDates;
          $[19] = t1;
        } else {
          t1 = $[19];
        }
        return t1;
      }
    case CreateWaveStep.DROPS:
      {
        let t1;
        if ($[20] !== config.drops || $[21] !== config.overview.type || $[22] !== errors || $[23] !== setDrops) {
          t1 = <CreateWaveDrops waveType={config.overview.type} drops={config.drops} errors={errors} setDrops={setDrops} />;
          $[20] = config.drops;
          $[21] = config.overview.type;
          $[22] = errors;
          $[23] = setDrops;
          $[24] = t1;
        } else {
          t1 = $[24];
        }
        return t1;
      }
    case CreateWaveStep.VOTING:
      {
        let t1;
        if ($[25] !== config.approval.threshold || $[26] !== config.overview.type || $[27] !== config.voting.category || $[28] !== config.voting.maxVotesPerIdentityPerDrop || $[29] !== config.voting.profileId || $[30] !== config.voting.timeWeighted || $[31] !== config.voting.type || $[32] !== errors || $[33] !== onCategoryChange || $[34] !== onMaxVotesPerIdentityPerDropChange || $[35] !== onProfileIdChange || $[36] !== onThresholdChange || $[37] !== onTimeWeightedVotingChange || $[38] !== onVotingTypeChange) {
          t1 = <CreateWaveVoting waveType={config.overview.type} selectedType={config.voting.type} category={config.voting.category} profileId={config.voting.profileId} maxVotesPerIdentityPerDrop={config.voting.maxVotesPerIdentityPerDrop} approvalThreshold={config.approval.threshold} errors={errors} onTypeChange={onVotingTypeChange} setCategory={onCategoryChange} setProfileId={onProfileIdChange} setMaxVotesPerIdentityPerDrop={onMaxVotesPerIdentityPerDropChange} setApprovalThreshold={onThresholdChange} timeWeighted={config.voting.timeWeighted} onTimeWeightedChange={onTimeWeightedVotingChange} />;
          $[25] = config.approval.threshold;
          $[26] = config.overview.type;
          $[27] = config.voting.category;
          $[28] = config.voting.maxVotesPerIdentityPerDrop;
          $[29] = config.voting.profileId;
          $[30] = config.voting.timeWeighted;
          $[31] = config.voting.type;
          $[32] = errors;
          $[33] = onCategoryChange;
          $[34] = onMaxVotesPerIdentityPerDropChange;
          $[35] = onProfileIdChange;
          $[36] = onThresholdChange;
          $[37] = onTimeWeightedVotingChange;
          $[38] = onVotingTypeChange;
          $[39] = t1;
        } else {
          t1 = $[39];
        }
        return t1;
      }
    case CreateWaveStep.APPROVAL:
      {
        return null;
      }
    case CreateWaveStep.OUTCOMES:
      {
        let t1;
        if ($[40] !== config.approval.maxWinners || $[41] !== config.dates || $[42] !== config.outcomes || $[43] !== config.overview.type || $[44] !== errors || $[45] !== onApprovalMaxWinnersChange || $[46] !== onOutcomeTypeChange || $[47] !== selectedOutcomeType || $[48] !== setOutcomes) {
          t1 = <CreateWaveOutcomes outcomes={config.outcomes} outcomeType={selectedOutcomeType} waveType={config.overview.type} errors={errors} dates={config.dates} maxWinners={config.approval.maxWinners} setOutcomeType={onOutcomeTypeChange} setOutcomes={setOutcomes} setMaxWinners={onApprovalMaxWinnersChange} />;
          $[40] = config.approval.maxWinners;
          $[41] = config.dates;
          $[42] = config.outcomes;
          $[43] = config.overview.type;
          $[44] = errors;
          $[45] = onApprovalMaxWinnersChange;
          $[46] = onOutcomeTypeChange;
          $[47] = selectedOutcomeType;
          $[48] = setOutcomes;
          $[49] = t1;
        } else {
          t1 = $[49];
        }
        return t1;
      }
    case CreateWaveStep.DESCRIPTION:
      {
        let t1;
        if ($[50] !== config.overview.image) {
          t1 = config.overview.image ? URL.createObjectURL(config.overview.image) : null;
          $[50] = config.overview.image;
          $[51] = t1;
        } else {
          t1 = $[51];
        }
        let t2;
        if ($[52] !== config.overview.name || $[53] !== t1) {
          t2 = {
            name: config.overview.name,
            image: t1,
            id: null
          };
          $[52] = config.overview.name;
          $[53] = t1;
          $[54] = t2;
        } else {
          t2 = $[54];
        }
        let t3;
        if ($[55] !== descriptionRef || $[56] !== onHaveDropToSubmitChange || $[57] !== profile || $[58] !== showDropError || $[59] !== t2) {
          t3 = <CreateWaveDescription ref={descriptionRef} profile={profile} showDropError={showDropError} wave={t2} onHaveDropToSubmitChange={onHaveDropToSubmitChange} />;
          $[55] = descriptionRef;
          $[56] = onHaveDropToSubmitChange;
          $[57] = profile;
          $[58] = showDropError;
          $[59] = t2;
          $[60] = t3;
        } else {
          t3 = $[60];
        }
        return t3;
      }
  }
  return null;
}